import {Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {LOCALE_CONFIG, Logger} from '@common-lib';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {ToasterService} from 'angular2-toaster';
import {TranslateService} from '@ngx-translate/core';
import {ConfirmPopupComponent} from '../../components/';
import {ConfigurationService, ProductSettingsService, VariantsService} from '../../pages-services';
import {saveAs} from 'file-saver/FileSaver';
import * as moment from 'moment';
import {TranslationsService} from '../../pages-services';

@Component({
    selector: 'app-settings-product-settings',
    templateUrl: './settings-product-settings.component.html',
    styleUrls: ['./settings-product-settings.component.scss']
})
export class SettingsProductSettingsComponent implements OnInit {
    editModalRef: BsModalRef;
    selectedRow: {
        id: number,
        key: string,
        value: string,
        locale: string,
        product: {
            id: number,
            name: string
        },
        new: boolean
    };
    searchTerm = '';
    isExporting = true;
    isUploading = false;
    locales = [];
    popup_message = '';
    popup_callback = '';

    @ViewChild('editFormTemplate')
    editFormTemplate: TemplateRef<any>;

    tableConfiguration = {
        searchEnabled: false,
        headerEnabled: true,
        orderEnabled: true,
        globalSearchEnabled: false,
        paginationEnabled: true,
        exportEnabled: false,
        clickEvent: false,
        selectRow: false,
        selectCol: false,
        selectCell: false,
        rows: 50,
        additionalActions: false,
        serverPagination: false,
        isLoading: false,
        detailsTemplate: false,
        groupRows: false,
        paginationRangeEnabled: true,
        collapseAllRows: false,
        checkboxes: false
    };

      columns = [
        {key: 'key', title: 'Key'},
        {key: 'value', title: 'Value'},
        {key: 'locale', title: 'Locale'},
        {key: 'actions', title: 'Actions'}
    ];
    data = [];
    rows = [];
    selected = new Set();
    originalRowForEdit: any = null;

    products;
    selectedProduct;
    selectedLocale;

    selectedVariant: string = '';
    variantList: string[];

    @ViewChild(ConfirmPopupComponent)
    confirmPopup: ConfirmPopupComponent;

    @ViewChild(ConfirmPopupComponent)
    confirmPopupTransfer: ConfirmPopupComponent;

    constructor(
        private route: ActivatedRoute,
        private productSettingsService: ProductSettingsService,
        private variantsService: VariantsService,
        private configurationService: ConfigurationService,
        private translate: TranslateService,
        private translationsService: TranslationsService,
        private toasterService: ToasterService,
        private modalService: BsModalService,
        private logger: Logger
    ) {
    }

    ngOnInit() {
        this.configurationService.getList('products', LOCALE_CONFIG.DEFAULT_LOCALE).subscribe(({result: {products}}) => {
            this.products = products;
            this.products.map(p => {
              p.description = p.name.toUpperCase();
              return p;
            });

            this.selectedProduct = this.products[0].id;
            this.selectedLocale = 'en-en';
            this.getList();
            this.isExporting = false;
        });
        this.variantsService.getList().subscribe((data) => {
          let d = data.variants.map(d => d.optionName);
          this.variantList = d.filter((item, index) => d.indexOf(item) === index);
      });
      this.translationsService.getLocalizations().subscribe((data) => {
        this.locales = data.reduce((acc, cur, i) => {
          cur.locales.forEach((locale) => {
            acc = [...acc, {
              localeName: locale,
              languageCode: cur.language,
              languageTitle: cur.title,
            }];
          });
          return acc;
        }, []);
        this.locales
          .sort((a, b) => a.localeName.localeCompare(b.localeName))
        this.locales = [{ localeName: 'Global'}, ...this.locales];
      });
    }

    addVariant() {
      if(this.selectedVariant) {
        let v = this.selectedRow.value.split(',').map(m => {
          return m.trim();
        });
        v.push(this.selectedVariant);
        let res = v.filter((item, index) => v.indexOf(item) === index);
        this.selectedRow.value = res.join(', ');
        this.selectedVariant = '';
      }
    }

    searchName(filter: string, item: string) {
      filter = filter.toLocaleLowerCase();
      return (item.toLocaleLowerCase().indexOf(filter) > -1);
    }

    getList() {
        this.productSettingsService.getList().subscribe((data) => {
            this.data = data;
            this.search();
        });
    }

    eventEmitted($event) {
        switch ($event.event) {
            case 'onSelectAll':
                this.data.forEach((val, key) => {
                    if (this.selected.has(key)) {
                        this.selected.delete(key);
                    } else {
                        this.selected.add(key);
                    }
                });
                break;
            case 'onDoubleClick':
                this.editRow($event.value.row);
                break;
        }
    }

    showEditForm(template: TemplateRef<any>) {
        this.editModalRef = this.modalService.show(template);
    }

    editRow(row) {
        this.selectedRow = row;
        this.selectedRow = this.originalRowForEdit = Object.assign({}, row);
        this.editModalRef = this.modalService.show(this.editFormTemplate);
    }

    toggleRow({target: {checked}}, row) {
        const index = this.data.indexOf(row);
        if (checked) {
            this.selected.add(index);
        } else {
            this.selected.delete(index);
        }
    }

    isRowSelected(row) {
        return this.selected.has(this.data.indexOf(row));
    }

    saveProductSetting() {
        this.editModalRef.hide();
        let locale = this.selectedRow.locale === 'Global' ? '' : this.selectedRow.locale;
        this.productSettingsService.update(
            this.selectedProduct,
            this.selectedRow.key,
            this.selectedRow.value,
            locale
        ).subscribe(async (result) => {
            this.getList();
            const successMessage = await this.translate.get('webpanel.product_settings.save.success_message').toPromise();
            this.toasterService.pop('success', '', successMessage);
        });
    }

    search() {
        let selectedLocale = this.selectedLocale === 'Global' ? '' : this.selectedLocale;
        this.rows = this.data.filter((r) =>
            r.product.id === this.selectedProduct && r.key && r.value &&
            (this.searchTerm.length === 0 || r.key.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1 || r.value.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1) &&
            (r.locale === selectedLocale)
        );
        return this.rows;
    }

    addNew() {
        let selectedLocale = this.selectedLocale === 'Global' ? '' : this.selectedLocale;
        this.selectedRow = {
            id: 0,
            key: '',
            value: '',
            locale: selectedLocale,
            product: {id: 0, name: ''},
            new: true
        };
        this.editModalRef = this.modalService.show(this.editFormTemplate);
    }

    searchKeyPress(event) {
        if (event.which === 13) {
            this.search();
        }
    }

    async removeItem(item) {
        this.selectedRow = item;
        if (this.selectedRow) {
            this.popup_message = await this.translate.get('webpanel.product_settings.remove_product_setting_confirmation', {'product_setting': this.selectedRow.key}).toPromise();
            this.popup_callback = 'delete';
            this.confirmPopup.show();
        }
    }

    async transferItem(item) {
        this.selectedRow = item;
        if (this.selectedRow) {
            this.popup_callback = 'transfer';
            this.popup_message = await this.translate.get('webpanel.product_settings.transfer_product_setting_confirmation', {'product_setting': this.selectedRow.key}).toPromise();
            this.confirmPopup.show();
        }
    }

    confirm(res) {
        if (res) {
            if (this.popup_callback === 'delete') {
              if (this.selectedRow) {
                this.productSettingsService.delete(this.selectedRow).subscribe(async (resp) => {
                  this.selectedRow = null;
                  const successMessage = await this.translate.get('webpanel.product_settings.delete.success_message').toPromise();
                  this.toasterService.pop('success', '', successMessage);
                  this.getList();
                });
              }
            } else if (this.popup_callback === 'transfer') {
                this.confirmTransfer(res);
            }
        } else {
            this.selectedRow = this.originalRowForEdit;
            this.originalRowForEdit = null;
        }
    }

    confirmTransfer(res) {
        if (res) {
            if (this.selectedRow) {
              let locale = this.selectedRow.locale === 'Global' ? '' : this.selectedRow.locale;
              this.productSettingsService.transfer(
                  this.selectedProduct,
                  this.selectedRow.id,
                  locale
              ).subscribe(async (result) => {
                this.getList();
                const successMessage = await this.translate.get('webpanel.product_settings.save.success_message').toPromise();
                this.toasterService.pop('success', '', successMessage);
              });
            }
        } else {
            this.selectedRow = this.originalRowForEdit;
            this.originalRowForEdit = null;
        }
    }

    decline() {
        this.selectedRow = this.originalRowForEdit;
        this.originalRowForEdit = null;
    }

    fileUpload({target}) {
        if (this.isUploading) {
            return;
        }
        this.isUploading = true;
        const fileField = target;
        const file = fileField.files[0];
        const reader = new FileReader();
        reader.onload = () => {
            const result = JSON.parse(reader.result);
            this.productSettingsService.uploadImport(this.selectedProduct, result).subscribe(async (response) => {
                this.isUploading = false;
                this.getList();
                if (response.success) {
                    let successMessage = await this.translate.get('webpanel.product_settings.import.success_message').toPromise();
                    this.toasterService.pop('success', '', successMessage);
                } else {
                    let errorMessage = await this.translate.get('webpanel.product_settings.import.error_message').toPromise();
                    this.toasterService.pop('error', '', errorMessage);
                }
                fileField.value = '';
            });
        };
        reader.readAsText(file);
    }

    async saveFile() {
        if (this.rows) {
            this.rows = this.data.filter((r) =>
              r.product.id === this.selectedProduct
            );
            this.isExporting = true;
            await this.saveToFileSystem(this.rows);
            this.search();
        }
    }

    sortData(value) {
      return value.split(',').sort((a, b) => a.trim() < b.trim() ? -1 : 1);
    }

    private async saveToFileSystem(response) {
        let res = response.map(s => {
          let val = s.value.split(',').map(v => v.trim());
          let uniqueArray = val.filter(function(item, pos) {
            return val.indexOf(item) == pos;
          });
          return {"key": s.key, "value": uniqueArray.join(', '), 'locale': s.locale};
        });
        let content = {"productSettings": res};
        let fileContent = JSON.stringify(content, null, 2);
        const blob = new Blob([fileContent], {type: 'text/plain'});
        const productName = this.products.find(p => p.id === this.selectedProduct).name;
        saveAs(blob, 'product-settings-' + productName + '-' + moment().format('YYYYMMDD-HHmm') + '.json');
        this.isExporting = false;
        const successMessage = await this.translate.get('webpanel.product_settings.export.success_message').toPromise();
        this.toasterService.pop('success', '', successMessage);
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/settings-product-settings/settings-product-settings.component.ts